import { render, staticRenderFns } from "./OrderFabricKnitTypeTable.vue?vue&type=template&id=1b732866&"
import script from "./OrderFabricKnitTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricKnitTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderFabricKnitTypeTable.vue?vue&type=style&index=0&id=1b732866&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports